import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import CssBaseline from "@mui/material/CssBaseline";
import { useSelector } from "react-redux";
import dynamic from 'next/dynamic'

const LocationSelectionPopup = dynamic(
    () => import('../location-popup/LocationSelectionPopup'),
    { ssr: false }
)

const HomeGuard = (props) => {
    const { children, from, page } = props
    const router = useRouter()
    const { cartList } = useSelector((state) => state.cart)
    const [checked, setChecked] = useState(false)
    const [showLocationPopup, setShowLocationPopup] = useState(false)

    useEffect(
        () => {
            if (!router.isReady) {
                return
            }
            if (from === "checkout" && cartList?.length === 0 && page !== 'campaign') {
                router.push('/home')
            }
            const zoneId = JSON.parse(localStorage.getItem('zoneid'))
            const location = localStorage.getItem('location')
            setChecked(true)
            if (!(zoneId?.length > 0 && location)) {
                setShowLocationPopup(true)
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [router.isReady]
    )

    const handleLocationSet = () => {
        setShowLocationPopup(false)
        router.reload()
    }

    if (!checked) {
        return null
    }

    return <>
        <CssBaseline />
        {children}
        {showLocationPopup && (
            <LocationSelectionPopup
                open={showLocationPopup}
                onLocationSet={handleLocationSet}
            />
        )}
    </>
}

HomeGuard.propTypes = {}

export default HomeGuard
